export const ACCEPTABLE_TYPES = ['image/', 'image/gif', 'image/webp'];
